import {
    SEARCH_PRACTICES_REQUEST,
    SEARCH_PRACTICES_RESULT,
    SEARCH_PRACTICE_ERROR,
} from '../ActionTypes';

const initialState = {
    practiceList: [],
    search: '',
    page: 1,
    totalPages: 0,
    searching: false,
    error: '',
};

const newPracticeReduction = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_PRACTICES_REQUEST:
            return {
                ...state,
                searching: true,
            };
        case SEARCH_PRACTICES_RESULT:
            return {
                ...state,
                searching: false,
                practiceList: action.payload.practices || [],
                page: 1,
                totalPages: action.payload.totalPages || 0,
            };
        case SEARCH_PRACTICE_ERROR:
            return {
                ...state,
                searching: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default newPracticeReduction;
